<script>
import TwConfirmDialog from '../../../components/TwConfirmDialog';
import { mapState } from 'vuex';
import Vue from 'vue';

export default {
  components: {
    TwConfirmDialog,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      required: true,
    },
    domainValues: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      toggled: false,
      image: null,
      height: null,
      width: null,
      confirm: false,
      formTitle: null,
      domains: {},
    };
  },
  computed: {
    ...mapState({
      selectedDomainId: state => state.ski.selectedDomainId,
    }),
    changed() {
      return this.title !== this.formTitle;
    },
  },
  watch: {
    selectedDomainId() {
      this.handleDomains();
    },
  },
  created() {
    this.formTitle = this.title;
    this.image = new Image();
    this.image.src = this.src;
    this.domains = this.domainValues;
    this.image.addEventListener('load', () => {
      this.height = this.image.height;
      this.width = this.image.width;
    });
    this.handleDomains();
  },
  methods: {
    remove() {
      this.confirm = false;
      this.toggled = false;
      this.$emit('remove');
    },
    toggle() {
      this.$refs.dialog.open();
    },
    reset() {
      this.formTitle = this.title;
    },
    update() {
      this.toggled = false;
      this.$emit('update', {
        title: this.formTitle,
        domains: this.domains,
      });
    },
    handleDomains() {
      if (this.selectedDomainId !== null) {
        if (!this.domains[this.selectedDomainId]) {
          Vue.set(this.domains, this.selectedDomainId, {
            domainId: this.selectedDomainId,
            title: '',
          });
        }
      }
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    :max-width="width"
  >
    <template v-slot:activator="{ on }">
      <v-flex class="ski-area-slope-maps-title">
        {{ title }}
      </v-flex>
      <v-img
        :src="src"
        :height="height"
        :width="width"
        class="ski-area-slope-maps-toggle-image"
        min-width="100%"
        min-height="100%"
        max-width="200px"
        max-height="200px"
        position="center center"
        v-on="on"
      />
    </template>
    <template>
      <v-card>
        <v-flex pa-3>
          <v-text-field
            v-model="formTitle"
            label="Global Title"
          />
          <v-text-field
            v-if="selectedDomainId !== null"
            v-model="domains[selectedDomainId].title"
            label="Domain title"
          />
          <v-img
            :src="src"
            :width="width"
            max-width="100%"
            contain
          />
        </v-flex>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <div>
            <v-btn
              color="primary"
              flat
              @click="update"
            >
              {{ $t('buttons.update') }}
            </v-btn>
          </div>
          <div v-if="!changed">
            <v-btn
              color="red"
              flat
              @click="toggle"
            >
              {{ $t('buttons.delete') }}
            </v-btn>
            <v-btn
              color="primary"
              flat
              @click="toggled = false"
            >
              {{ $t('buttons.close') }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </template>
    <template>
      <tw-confirm-dialog
        ref="dialog"
        :title="$t('slopeMaps.image.alert')"
        :description="$t('slopeMaps.image.confirm')"
        @confirm="remove"
      />
    </template>
  </v-dialog>
</template>

<style lang="scss">
  .ski-area-slope-maps-title {
    position: absolute;
    font-size: 16px;
    z-index: 10;
    color: white;
    margin: 5px;
    text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
  }

  .ski-area-slope-maps-toggle-image {
    cursor: pointer;
    opacity: 1;
    transition: .2s opacity ease;

    &:hover {
      opacity: .8;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ski/areas/SkiAreaSlopeMapsImage.vue